import { Service, inject } from '@angular/core'
import { GetManagedEntityCalendarItemsQuery, GetManagedEntityCalendarItemsResponse } from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManageEntityCalendarItemsApiService {
  private readonly api = inject(ApiService)

  getManagedEntityCalendarItems(entityId: string, query: GetManagedEntityCalendarItemsQuery, init?: RequestInit) {
    const url = this.api.createURL(`manage/entities/${entityId}/calendar-items`)
    url.search = this.api.toQueryParams(query)
    return this.api.protectedFetchJson<GetManagedEntityCalendarItemsResponse>(url, { ...init })
  }
}
